import React from 'react'
import styled from 'styled-components'

// Elements
import ImageBackground from 'components/shared/ImageBackground'
import ParseContent from 'components/shared/ParseContent'

const Hero = styled(ImageBackground)`
  @media (min-width: 992px) {
    min-height: 720px;
  }

  @media (max-width: 991px) {
    min-height: 450px;
  }
`

const Content = styled(ParseContent)`
  & h3 {
    font-size: ${(props) => props.theme.font.size.xl};
    margin-bottom: 1rem;

    @media (max-width: 991px) {
      font-size: ${(props) => props.theme.font.size.l};
    }
  }

  & p {
    font-size: ${(props) => props.theme.font.size.l};
    color: ${(props) => props.theme.color.text.contrast};
    text-align: center;

    @media (max-width: 991px) {
      font-size: ${(props) => props.theme.font.size['20']};
    }
  }
`

const HeroSecond = ({ fields, withDescription }) => {
  return (
    <Hero src={fields.image} aboveFold>
      {withDescription && (
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <Content content={fields.bibletext} />
          </div>
        </div>
      )}
    </Hero>
  )
}
export default HeroSecond
